export { default as StrategyTeamsDropdown } from './StrategyTeamsDropdown';
